var BREAKPOINTS;
(function (BREAKPOINTS) {
    BREAKPOINTS[BREAKPOINTS["xs"] = 0] = "xs";
    BREAKPOINTS[BREAKPOINTS["sm"] = 576] = "sm";
    BREAKPOINTS[BREAKPOINTS["md"] = 768] = "md";
    BREAKPOINTS[BREAKPOINTS["lg"] = 992] = "lg";
    BREAKPOINTS[BREAKPOINTS["xl"] = 1200] = "xl";
    BREAKPOINTS[BREAKPOINTS["hd"] = 1440] = "hd";
})(BREAKPOINTS || (BREAKPOINTS = {}));

export { BREAKPOINTS };
//# sourceMappingURL=breakpoints.js.map
